import { h } from 'preact'
import EventIcon from './assets/eventIcon.js'
import ButtonControl from '../button-control/index'
import Title from './Title'

interface Props {
  hasUnsavedChanges: boolean,
  published: boolean,
  title: string,
  error: string,
  csvDownloadUrl: string,
  csvDownloadText: string,
  onTitleChanged: CallableFunction,
  onPublish: OnClickCallback,
  onDeleteHandler: OnClickCallback
}

const Header = ({ hasUnsavedChanges, title, error, onTitleChanged, onPublish, csvDownloadUrl, csvDownloadText, published }: Props) => {
  const buttonTitle = published ? (hasUnsavedChanges ? 'Save changes' : 'All saved') : 'Publish'
  return (
    <div class='control-header'>
      <div class='event-creator__event-icon-circle'>
        <EventIcon />
      </div>
      <Title
        title={title}
        error={error}
        onTitleChanged={(title: string) => onTitleChanged(title)}
        hasUnsavedChanges={hasUnsavedChanges}
        published={published}
      />
      <div class='event-creator__action-buttons'>
        {published && <a class='event-creator__button-download qa-download-csv' href={csvDownloadUrl} target='_blank'>{csvDownloadText}</a>}
        <ButtonControl variant={'primary'} title={buttonTitle} class='qa-publish' disabled={published && !hasUnsavedChanges} onClick={onPublish} />
      </div>
    </div>
  )
}

export default Header
